import React, { useEffect, useMemo, useState } from 'react'
import { useDeclineReasonsQuery } from '../../../api/react-query/dict'
import { Button, Divider, Input, Radio, Select, Space } from 'antd'
import { ACCEPT, ACCEPTED, DECLINE, DECLINED } from '../../../Constants'
import './ApprovalAction.css'
const radioStyle = { height: '30px', lineHeight: '30px' }

const ApprovalAction = ({ targetType, disabled, onAccept, onDecline, onClose, defaultComment = null, defaultOutcome = null, isShowDescription = false }) => {
  const lastApprovalAction = useMemo(() => {
    if (defaultOutcome === ACCEPTED) return ACCEPT
    if (defaultOutcome === DECLINED) return DECLINE
    return null
  }, [defaultOutcome])
  const [actionType, setActionType] = useState(lastApprovalAction)
  const [commentOptions, setCommentOptions] = useState([])
  const [selectedReason, setSelectedReason] = useState(undefined)
  const [description, setDescription] = useState('')

  const { data: dataDeclineReasons, isSuccess: isSuccessReasons } =
    useDeclineReasonsQuery(targetType, {
      enabled: Boolean(targetType)
    })

  useEffect(() => {
    if (isShowDescription && defaultComment) {
      setSelectedReason(defaultComment)
      return
    }
    if (defaultComment && dataDeclineReasons?.result.length > 0) {
      const comment = defaultComment
      const arrSelectedReasons = []
      dataDeclineReasons.result.forEach(declineReason => {
        if (comment.includes(declineReason.reason)) {
          comment.replace(declineReason.reason, '')
          arrSelectedReasons.push(declineReason.reason)
        }
      })
      setSelectedReason(arrSelectedReasons)
    }
  }, [isShowDescription, defaultComment, dataDeclineReasons?.result])

  useEffect(() => {
    if (isShowDescription && selectedReason && dataDeclineReasons?.result.length > 0) {
      const declineReason = dataDeclineReasons.result.find((declineReason) => declineReason.reason === selectedReason)
      if (declineReason) setDescription(declineReason.description)
    }
  }, [isShowDescription, selectedReason, dataDeclineReasons?.result])

  useEffect(() => {
    if (isSuccessReasons && dataDeclineReasons?.isSuccess) {
      setCommentOptions(
        dataDeclineReasons.result.map((item) => ({
          label: item.reason,
          value: item.reason
        }))
      )
    }
  }, [dataDeclineReasons, isSuccessReasons])

  const handleChangeActionType = e => {
    setActionType(e.target.value)
  }

  const canSubmit = (!disabled && actionType === ACCEPT) || (actionType === DECLINE && selectedReason && ((!isShowDescription && !description) || (isShowDescription && description)))

  return (
    <Space direction='vertical' style={{ width: '100%' }}>
      <>
        <Radio.Group
          defaultValue={ACCEPT}
          onChange={handleChangeActionType}
          value={actionType}
        >
          <Space direction='vertical'>
            <Radio style={radioStyle} value={ACCEPT}>
              Принять
            </Radio>
            <Radio
              style={{ height: '30px', lineHeight: '30px' }}
              value={DECLINE}
            >
              Требуются изменения
            </Radio>
          </Space>
        </Radio.Group>
      </>
      {actionType === DECLINE && commentOptions.length > 0 && (
        <>
          <Select
            mode={isShowDescription ? undefined : 'multiple'}
            className='approval-select'
            showSearch
            placeholder='Выберите причину'
            optionFilterProp='children'
            style={{ width: '100%' }}
            value={selectedReason}
            onChange={value => setSelectedReason(value)}
            filterOption={(input, option) => (
              option?.children?.toLowerCase().includes(input.toLowerCase())
            )}
            getPopupContainer={trigger => trigger.parentElement}
          >
            {dataDeclineReasons.result.map(item => (
              <Select.Option key={item.reason} value={item.reason}>
                {item.reason}
              </Select.Option>
            ))}
          </Select>
          {isShowDescription && (
            <Input.TextArea
              style={{ width: '100%', marginBottom: '1rem' }}
              rows={4}
              onChange={(e) => setDescription(e.target.value)}
              placeholder='Введите уточнение'
              allowClear
              value={description}
            />
          )}
        </>
      )}
      <div>
        <Button
          type='primary'
          disabled={!canSubmit}
          onClick={() => actionType === ACCEPT ? onAccept() : onDecline(isShowDescription ? selectedReason : selectedReason.join(' '), description)}
        >
          Сохранить
        </Button>
        <Divider type='vertical' />
        <Button
          type='default'
          onClick={() => {
            setSelectedReason(null)
            setActionType(null)
            onClose && onClose()
          }}
        >
          Отмена
        </Button>
      </div>
    </Space>
  )
}

export default ApprovalAction
